<template>
  <div class="form-row">
    <form
      :class="{
        'loading-opacity': preloader,
        'col-sm-12 p-4': isAdmin,
        'mb-0 ml-sm-4 col-md-12': !isAdmin,
      }"
    >
      <div class="form-group">
        <div class="col-12 mb-4">
          <h4 class="text-center">Address Coverage (Past 5 Years)</h4>
          <history-pie-chart :chart-data="pieChartData" />
        </div>
        <h3 class="text-center mb-0">Address Information</h3>
        <div v-if="restrictValidation && gaps.length > 0" class="gap-warning mt-4">
          <h4 class="text-danger">⚠ Address Gaps Found</h4>
          <ul class="text-danger">
            <li v-for="(gap, index) in gaps" :key="index">
              Missing period: {{ dateFormatter(gap.start) }} to
              {{ dateFormatter(gap.end) }} ({{gap.duration}})
            </li>
          </ul>
        </div>
      </div>
      <div class="d-flex flex-wrap justify-content-between">
        <div class="col-md-6 my-2" v-for="(item, index) in address_Info" :key="index">
          <div class="card-item">
            <div class="form-group row align-items-center">
              <label class="col-sm-12 mb-sm-1 current-address" v-if="item.current_status"
                >Current Address</label
              >
              <div class="col-8">
                <label class="col-sm-12 mb-sm-1">Address No. {{ index + 1 }}</label>
                  <label class="col-sm-12 mb-sm-1"
                         :class="{'d-flex align-items-center': isLongAddress(item.address) && !expandedAddresses[index] && !hideReadMore}">
                    <span 
                      :class="{'text-truncate': isLongAddress(item.address) && !expandedAddresses[index] && !hideReadMore}"
                      :style="{
                        'display': (isLongAddress(item.address) && !expandedAddresses[index] && !hideReadMore) ? 'block' : 'inline',
                        'max-width': (isLongAddress(item.address) && !expandedAddresses[index] && !hideReadMore) ? '100%' : 'unset'
                      }"
                    >
                      {{ item.address }}
                    </span>
                    <a 
                      v-if="isLongAddress(item.address) && !expandedAddresses[index] && !hideReadMore" 
                      href="#" 
                      class="ml-1 text-nowrap" 
                      @click.prevent="toggleAddressExpand(index)"
                    >
                      Read more
                    </a>
                    <a 
                      v-if="isLongAddress(item.address) && expandedAddresses[index] && !hideReadMore" 
                      href="#" 
                      class="ml-1" 
                      @click.prevent="toggleAddressExpand(index)"
                    >
                      Show less
                    </a>
                  </label>

                <label class="col-sm-12 mb-sm-1"
                  >{{ dateFormatter(item.from_date) }} /
                  {{ item.current_status ? '(Current)' : dateFormatter(item.to_date) }}</label
                >
                <label class="col-sm-12 mb-sm-1">{{
                  getDurationText(item)
                }}</label>
              </div>
                <div class="col-4" v-if="isAdmin">
                <div v-if="item.screening_endorsement && item.screening_endorsement.requested_at">
                  Endorsements
                  <p>
                    <strong>Requested At:</strong>
                    {{ item.screening_endorsement.requested_at }}
                  </p>
                  <p v-if="item.screening_endorsement.endorsed_at">
                    <strong>Endorsed At:</strong>
                    {{ item.screening_endorsement.endorsed_at }}
                  </p>
                  <p><strong>Status:</strong> {{ item.screening_endorsement.status }}</p>
                </div>
                <div
                  v-if="getLatestStatus(item)"
                  :class="getHighlightClass(getLatestStatus(item))"
                  :style="getHighlightStyle(getLatestStatus(item))"
                >
                  {{ getStatusValue(getLatestStatus(item)) }}
                </div>

                <div v-if="!getLatestStatus(item)" class="highlight-orange">
                  Verification Pending
                </div>
              </div>
                <div class="col-4">
                <div
                  v-if="!isAdmin && isRevertToApplicant(getLatestStatus(item))"
                  class="highlight-orange"
                >
                  To do: {{ getStatusComment(getLatestStatus(item)) }}
                  </div>
                </div>
                  <div class="col-sm-12 mt-sm-3 d-flex flex-wrap" v-if="!isReadOnly">
                <el-button
                  class="btn btn-danger el-button--default float-right"
                  :style="{ marginLeft: '15px' }"
                             @click="openFormInModal(index)">
                    Edit
                </el-button>
                <el-button
                  class="btn btn-danger el-button--default float-right mr-sm-2"
                  @click="removeBtnHandler(index)"
                >
                  Remove
                </el-button>
                <div class="col-md-4 mr-sm-2" v-if="isAdmin">
                  <drawer-component
                    title="Comments"
                    size="80%"
                    btnText="Take Action"
                    v-if="hasScreeningSchedule"
                    :open="true"
                  >
                    <address-comments
                      :comment="item.screening_status"
                      :applicantId="candidateId"
                      :statusable_type="item.statusable_type"
                      :statusable_id="item.id"
                      :address="item"
                      :emailAddress="emailAddress"
                      @status-updated="handleStatusUpdate(item, $event)"
                      @status-deleted="onAddressStatusDeleted(item, $event)"
                    />
                  </drawer-component>
                    <div v-else class="screening-note">
                      Add this profile to Screening to proceed.
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6" v-if="!isReadOnly">
        <div class="form-group row align-items-center">
          <label class="h2 col-sm-12">
            {{ address_count === 0 ? "Add Current Address" : "Add Previous Address" }}
          </label>
        </div>

        <!-- Search for an address -->
        <!--        <div class="form-group row align-items-center">-->
        <!--          <label class="col-sm-2 mb-sm-0">Search by post code</label>-->
        <!--          <app-input class="col-sm-8 mb-sm-2"-->
        <!--                     type="post-code"-->
        <!--                     v-model="addressObj.post_code"-->
        <!--                     @postal-code-found="updateAddressCoordinates"-->
        <!--                     placeholder="Start typing your postal code ..."/>-->
        <!--        </div>-->

        <!-- Street -->
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">Is Current Address?</label>
          <el-checkbox
            v-model="addressObj.current_status"
            @change="handleCurrentStatusChange"
          />
        </div>
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">Door No.</label>

          <app-input
            type="text"
            v-model="addressObj.door_number"
            placeholder="Door No."
            @blur="$v.addressObj.door_number.$touch()"
          />
          <div class="error" v-if="restrictValidation && $v.addressObj.door_number.$error">
            {{ $t("field_is_required") }}
          </div>
        </div>
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">Street</label>

          <app-input
            type="text"
            v-model="addressObj.street"
            placeholder="Street"
            @blur="$v.addressObj.street.$touch()"
          />
          <div class="error" v-if="restrictValidation && $v.addressObj.street.$error">
            {{ $t("field_is_required") }}
          </div>
        </div>

        <!-- Town or city -->
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">City</label>

          <app-input
            type="text"
            v-model="addressObj.city"
            placeholder="Town or city"
            @blur="$v.addressObj.city.$touch()"
          />
          <div class="error" v-if="restrictValidation && $v.addressObj.city.$error">
            {{ $t("field_is_required") }}
          </div>
        </div>

        <!-- County -->
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">County</label>

          <app-input
            type="text"
            v-model="addressObj.county"
            placeholder="County"
            @blur="$v.addressObj.county.$touch()"
          />
          <div class="error" v-if="restrictValidation && $v.addressObj.county.$error">
            {{ $t("field_is_required") }}
          </div>
        </div>

        <!-- Postcode -->
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">Post Code</label>

          <app-input
            type="text"
            v-model="addressObj.post_code"
            placeholder="Postcode"
            @blur="$v.addressObj.post_code.$touch()"
          />
          <div class="error" v-if="restrictValidation && $v.addressObj.post_code.$error">
            {{ $t("field_is_required") }}
          </div>
        </div>

        <!-- Country -->
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">Country:</label>

          <app-input
            type="text"
            v-model="addressObj.country"
            placeholder="Country"
            @blur="$v.addressObj.country.$touch()"
          />
          <div class="error" v-if="restrictValidation && $v.addressObj.country.$error">
            {{ $t("field_is_required") }}
          </div>
        </div>

        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">From Date</label>
          <app-input
            type="date"
            v-on:blur="$v.addressObj.from_date.$touch()"
            v-model="addressObj.from_date"
            :max-date="addressObj.current_status ? new Date() : null"
            placeholder=""
          />

          <div class="error col-sm-12" v-if="!$v.addressObj.from_date.isValidFromDate">
            From Date Can't Be Greater Than To Date.
          </div>
        </div>
        <div class="form-group row align-items-center" v-if="!addressObj.current_status">
          <label class="col-sm-2 mb-sm-0">To Date</label>
          <app-input
            type="date"
            v-model="addressObj.to_date"
            v-on:blur="$v.addressObj.to_date.$touch()"
            :read-only="false"
            :disabled="false"
          />
          <div class="error col-sm-2" v-if="restrictValidation && $v.addressObj.to_date.$error">
            {{ $t("field_is_required") }}
          </div>
        </div>

        <!-- To Date (hidden but stored when current) -->
        <app-input
          type="hidden"
          v-if="addressObj.current_status"
          :value="addressObj.to_date"
        />

        <div class="form-group row align-items-center">
          <div class="col-sm-12">
            <el-button class="btn el-button--success" @click="addBtnHandler()">
              Save & Add New
            </el-button>
          </div>
        </div>
        <div class="form-group row align-items-center" v-if="restrictValidation">
          <h6 class="text-center mb-0">
            {{ $t("five_years_error") }}
          </h6>
        </div>
      </div>

      <template v-if="is_modal">
        <app-modal
          :modal-id="modalId"
          modal-alignment="top"
          modal-size="fullscreen"
          @close-modal="closeModal"
        >
          <template slot="header">
            <h5 class="modal-title">{{ $t("Edit Address") }}</h5>
            <button
              type="button"
              class="close outline-none"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span>
                <app-icon :name="'x'"></app-icon>
              </span>
            </button>
          </template>
          <template slot="body">
            <div class="card card-with-search border-0 card-with-shadow">
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">Is Current Address?</label>
                <el-checkbox
                  v-model="addressObj.current_status"
                  @change="handleCurrentStatusChange"
                />
              </div>
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">Door No.</label>

                <app-input
                  type="text"
                  v-model="addressObj.door_number"
                  placeholder="Door No."
                  @blur="$v.addressObj.door_number.$touch()"
                />
                <div class="error" v-if="restrictValidation && $v.addressObj.door_number.$error">
                  {{ $t("field_is_required") }}
                </div>
              </div>
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">Street</label>

                <app-input
                  type="text"
                  v-model="addressObj.street"
                  placeholder="Street"
                  @blur="$v.addressObj.street.$touch()"
                />
                <div class="error" v-if="restrictValidation && $v.addressObj.street.$error">
                  {{ $t("field_is_required") }}
                </div>
              </div>

              <!-- Town or city -->
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">City</label>

                <app-input
                  type="text"
                  v-model="addressObj.city"
                  placeholder="Town or city"
                  @blur="$v.addressObj.city.$touch()"
                />
                <div class="error" v-if="restrictValidation && $v.addressObj.city.$error">
                  {{ $t("field_is_required") }}
                </div>
              </div>

              <!-- County -->
              <!--              <div class="form-group row align-items-center">-->
              <!--                <label class="col-sm-2 mb-sm-0">County</label>-->

              <!--                <app-input-->
              <!--                    type="text"-->
              <!--                    v-model="addressObj.county"-->
              <!--                    placeholder="County"-->
              <!--                    @blur="$v.addressObj.county.$touch()"-->
              <!--                />-->
              <!--                <div class="error" v-if="$v.addressObj.county.$error">-->
              <!--                  {{ $t('field_is_required') }}-->
              <!--                </div>-->
              <!--              </div>-->

              <!-- Postcode -->
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">Post Code</label>

                <app-input
                  type="text"
                  v-model="addressObj.post_code"
                  placeholder="Postcode"
                  @blur="$v.addressObj.post_code.$touch()"
                />
                <div class="error" v-if="restrictValidation && $v.addressObj.post_code.$error">
                  {{ $t("field_is_required") }}
                </div>
              </div>

              <!-- Country -->
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">Country:</label>

                <app-input
                  type="text"
                  v-model="addressObj.country"
                  placeholder="Country"
                  @blur="$v.addressObj.country.$touch()"
                />
                <div class="error" v-if="restrictValidation && $v.addressObj.country.$error">
                  {{ $t("field_is_required") }}
                </div>
              </div>

              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">From Date</label>
                <app-input
                  type="date"
                  v-on:blur="$v.addressObj.from_date.$touch()"
                  v-model="addressObj.from_date"
                  :max-date="addressObj.current_status ? new Date() : null"
                  placeholder=""
                />
                <div
                  class="error col-sm-12"
                  v-if="!$v.addressObj.from_date.isValidFromDate"
                >
                  From Date Can't Be Greater Than To Date.
                </div>
              </div>
              <div class="form-group row align-items-center" v-if="!addressObj.current_status">
                <label class="col-sm-2 mb-sm-0">To Date</label>
                <app-input
                  type="date"
                  v-model="addressObj.to_date"
                  v-on:blur="$v.addressObj.to_date.$touch()"
                  :read-only="false"
                  :disabled="false"
                />
                <div class="error col-sm-2" v-if="restrictValidation && $v.addressObj.to_date.$error">
                  {{ $t("field_is_required") }}
                </div>
              </div>
            </div>
          </template>
          <template slot="footer">
            <button
              type="button"
              class="btn btn-secondary mr-2"
              data-dismiss="modal"
              @click="updateForm"
            >
              Update
            </button>
            <button
              type="button"
              class="btn btn-primary mr-2"
              data-dismiss="modal"
              @click="closeModal"
            >
              {{ $t("Close") }}
            </button>
          </template>
        </app-modal>
      </template>
    </form>
  </div>
</template>

<script>
import { ModalMixin } from "../../../../../../app/Mixins/ModalMixin";
import { required, minLength } from "vuelidate/lib/validators";
import { FormMixin } from "@/core/mixins/form/FormMixin";
import HistoryPieChart from './HistoryPieChart.vue';
import {
  getHighlightClass,
  calculateDifference,
  getHighlightStyle,
  getLatestStatus,
  getStatusComment,
  getStatusValue,
  isRevertToApplicant,
} from "@Views/Screening/utility/common";
import { _statusColors } from "@Views/Screening/utility/constant";
import axios from 'axios'

export default {
  name: "AddressInfo",
  mixins: [FormMixin, ModalMixin],
  components: {
    HistoryPieChart
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    restrictValidation: {
      type: Boolean,
      default: true,
    },
    yesOrNoList: {
      type: Array,
    },
    address_Info: {
      type: Array,
      required: true,
    },
    dateFormatter: {
      type: Function,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    candidateId: {
      type: Number,
    },
    emailAddress: {
      type: String,
    },
    onSaveBtn: Function,
    // When true, hide the "Read more" / "Show less" links (useful for print/download views)
    hideReadMore: {
      type: Boolean,
      default: false,
    },
    screeningSchedule: {
      type: [Object, Array],
      default: null,
    },
  },
  mounted() {
    this.setToDate();
  },
  destroyed() {
  },
  created() {
    this.$hub.$emit("candidateDetailActiveIndex", 3);
  },
  data() {
    return {
      addressObj: {
        city: "",
        country: "",
        door_number: "",
        from_date: null,
        post_code: "",
        street: "",
        to_date: null,
        county: "",
      },
      // track which address entries are expanded (by index)
      expandedAddresses: {},
      is_modal: false,
      update_index: 0,
      modalId: "address_modal",
      statusColors: _statusColors,
      deletingIndex: null,
    };
  },
  watch: {
    // When modal closes reset expanded state for the edited address
    is_modal(val) {
      if (!val) {
        // nothing extra needed
      }
    }
  },
  methods: {
    emptyAddressObj(toDate = null) {
      return {
        city: "",
        country: "",
        door_number: "",
        from_date: null,
        post_code: "",
        street: "",
        to_date: toDate,
        county: "",
        current_status: false,
      };
    },
    checkAddressAtIndex(index) {
      // kept for backward compatibility — no-op now
    },
    handleResize() {
      // no-op — DOM measurement removed
    },
    calculateDifference,
    getHighlightStyle,
    getStatusComment,
    getLatestStatus,
    getStatusValue,
    isRevertToApplicant,
    getHighlightClass,
    /**
     * Return a safe duration string for an address item.
     * Falls back to using current date when `to_date` is missing/invalid
     * and returns an empty string if `from_date` is invalid.
     */
    getDurationText(item) {
      if (!item || !item.from_date) return "";

      // Normalize from_date
      const from = new Date(item.from_date);
      if (isNaN(from.getTime())) return "";

      // If address is marked current or to_date is missing/invalid, use today
      let to;
      if (item.current_status) {
        to = new Date();
      } else if (item.to_date) {
        const parsed = new Date(item.to_date);
        to = isNaN(parsed.getTime()) ? new Date() : parsed;
      } else {
        to = new Date();
      }

      try {
        return this.calculateDifference(to, from);
      } catch (e) {
        // If the underlying util throws for unexpected input, fall back gracefully
        console.error('calculateDifference failed', e);
        return "";
      }
    },
    handleCurrentStatusChange(isChecked) {
      // For a current address we shouldn't store an end date
      if (isChecked) {
        this.addressObj.to_date = null;

        // If "From Date" was already selected and it's in the future, clear it.
        // A "Current Address" cannot have a start date in the future.
        if (this.addressObj.from_date) {
          const fromDate = new Date(this.addressObj.from_date);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          if (fromDate > today) {
            this.addressObj.from_date = null;
          }
        }
      } else {
        // Clear to_date so the user can enter one
        this.addressObj.to_date = null;
      }
    },
    isLongAddress(address) {
      if (!address) return false;
      return String(address).length > 60;
    },
    toggleAddressExpand(index) {
      const current = !!this.expandedAddresses[index];
      this.$set(this.expandedAddresses, index, !current);
    },
    addBtnHandler() {
      if (!this.$v.$invalid) {
        // Ensure only one is current
        if (this.addressObj.current_status) {
          this.address_Info.forEach((addr) => (addr.current_status = false));
        }

        // Construct the address string from individual fields
        const addressParts = [
          this.addressObj.door_number,
          this.addressObj.street,
          this.addressObj.city,
          this.addressObj.county,
          this.addressObj.post_code,
          this.addressObj.country,
        ].filter((part) => part && part.trim() !== "");
        const addressString = addressParts.join(", ");

        // Normalize current_status to boolean and clear to_date when current
        const normalized = { ...this.addressObj, current_status: !!this.addressObj.current_status };
        // ensure the combined address string is stored so new entries render immediately
        normalized.address = addressString;
        if (normalized.current_status) normalized.to_date = '';

        const nextToDate = normalized.from_date || null;
        this.address_Info.push(normalized); // Shallow copy with normalized current_status
        this.addressObj = this.emptyAddressObj(nextToDate);
        this.$v.addressObj.$reset();

        try {
          this.onSaveBtn();
        } catch (e) {
          console.error(e);
        }
      }
    },

    openFormInModal(index) {
      // Create a shallow copy so edits inside modal don't mutate the list until user saves
      this.addressObj = Object.assign({}, this.address_Info[index]);
      // Normalize `current_status` to a boolean so checkboxes reflect correctly
      this.addressObj.current_status = !!this.addressObj.current_status;
      this.update_index = index;
      // If this address is marked current, ensure to_date is cleared so modal hides the field
      if (this.addressObj.current_status) this.addressObj.to_date = null;
      this.is_modal = true;
    },
    async removeBtnHandler(index) {
      const item = this.address_Info[index];

      // Confirm deletion with the user (single clear message)
      if (!confirm('Are you sure you want to delete this entry?')) {
        return;
      }

      // mark deleting state to disable button
      this.deletingIndex = index;

      // If the address has an id, delete from server using a single sensible route
      if (item && item.id) {
        // ensure CSRF token header if present in page
        const tokenMeta = document.querySelector('meta[name="csrf-token"]');
        if (tokenMeta && !axios.defaults.headers.common['X-CSRF-TOKEN']) {
          axios.defaults.headers.common['X-CSRF-TOKEN'] = tokenMeta.getAttribute('content');
        }

        // prefer candidate-scoped endpoint when candidateId is available
        const url = this.candidateId ? `/api/candidates/${this.candidateId}/addresses/${item.id}` : `/api/addresses/${item.id}`;

        try {
          await axios.delete(url);
        } catch (e) {
          console.error('Failed to delete address from server', e);
          const msg = e?.response?.data?.message || e?.message || 'Failed to delete address';
          alert(msg);
          this.deletingIndex = null;
          return; // stop local deletion if server delete failed
        }
      }

      // Remove from local list
      if (this.address_Info.length > 0) {
        this.address_Info.splice(index, 1);
      }
      this.setToDate();
      try {
        this.onSaveBtn && this.onSaveBtn();
      } catch (e) {
        console.error(e);
      }
    },
    updateForm() {
      if (!this.$v.$invalid) {
        // Normalize current_status to boolean and clear to_date when current
        const normalized = { ...this.addressObj, current_status: !!this.addressObj.current_status };
        if (normalized.current_status) normalized.to_date = null;
        // Recompute the combined address string so updates show immediately
        const parts = [
          normalized.door_number,
          normalized.street,
          normalized.city,
          normalized.county,
          normalized.post_code,
          normalized.country,
        ].filter((p) => p && String(p).trim() !== "");
        normalized.address = parts.join(', ');
        
        // Use Vue.set (this.$set) to ensure reactivity when replacing an array item
        this.$set(this.address_Info, this.update_index, normalized);

        $(`#${this.modalId}`).modal('hide');

        // Persist changes via parent handler if provided
        try {
          if (typeof this.onSaveBtn === 'function') {
            this.onSaveBtn();
          }
        } catch (e) {
          console.error(e);
        }
      }
    },
    updateAddressCoordinates(addressObjPassed) {
      this.addressObj.street = addressObjPassed.lsoa;
      this.addressObj.city = addressObjPassed.admin_district;
      this.addressObj.county = addressObjPassed.admin_county ?? `-`;
      this.addressObj.post_code = addressObjPassed.postcode;
      this.addressObj.country = addressObjPassed.country;
    },
    setToDate() {
      this.$set(this.addressObj, "to_date", null);
    },
    closeModal() {
      this.addressObj = this.emptyAddressObj();
      this.$v.addressObj.$reset();
      this.$emit("close-modal");
      this.is_modal = false;
    },
    onAddressStatusDeleted(addressItem, payload){
      try{
        if (!addressItem || !Array.isArray(addressItem.screening_status)) return;
        const idx = addressItem.screening_status.findIndex(s => s.id === payload.id);
        if (idx !== -1){
          addressItem.screening_status.splice(idx,1);
        }
      }catch(e){
        console.error(e);
      }
    },
    handleStatusUpdate(addressItem, payload) {
      try {
        if (!addressItem) return;
        if (!addressItem.screening_status) {
          this.$set(addressItem, "screening_status", []);
        }
        
        // Check if this is an update to existing status or a new one
        const existingIndex = addressItem.screening_status.findIndex(s => s.id === payload.id);
        
        if (existingIndex !== -1) {
          // Update existing status
          this.$set(addressItem.screening_status, existingIndex, {
            ...addressItem.screening_status[existingIndex],
            action_comment: payload.action_comment,
            created_at: payload.created_at,
            include_in_report: payload.include_in_report ?? addressItem.screening_status[existingIndex].include_in_report,
            applicant_files: payload.applicant_files || []
          });
        } else {
          // Add new status
          addressItem.screening_status.push({
            ...payload,
            include_in_report: !!payload.include_in_report,
          });
        }

        if (payload.screening_endorsement) {
          this.$set(addressItem, "screening_endorsement", payload.screening_endorsement);
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
  computed: {
    hasScreeningSchedule() {
      const s = this.screeningSchedule || this.address_Info?.screeningSchedule;
      if (!s) return false;
      if (Array.isArray(s)) return s.length > 0;
      if (typeof s === "object") return Object.keys(s).length > 0;
      return !!s;
    },
    address_count() {
      return this.address_Info.length ?? 0;
    },
    sortedAddresses() {
      // Sort addresses from most recent to oldest
      return [...this.address_Info].sort(
        (a, b) => new Date(b.from_date) - new Date(a.from_date)
      );
    },
    pieChartData() {
      const totalDays = 365 * 5;
      
      // Calculate total gap days from the gaps computed property
      const gapDays = this.gaps.reduce((total, gap) => total + gap.days, 0);
      
      // Filled days = total days minus gap days
      const filledDays = Math.max(0, totalDays - gapDays);
      const missingDays = Math.max(0, gapDays);

      return {
        labels: ['Filled History', 'Missing History'],
        datasets: [
          {
            backgroundColor: ['#42b983', '#ff4d4f'],
            data: [filledDays, missingDays]
          }
        ]
      };
    },
    gaps() {
      let gaps = [];
      
      // Use screening creation date if available, otherwise use today's date
      let referenceDate = new Date();
      const screeningSchedule = this.screeningSchedule || this.address_Info?.screeningSchedule;
      
      if (screeningSchedule && screeningSchedule.created_at) {
        try {
          // Parse the created_at (screening creation date)
          referenceDate = new Date(screeningSchedule.created_at);
        } catch (e) {
          // Failed to parse, will use today's date
        }
      }
      
      const fiveYearsAgo = new Date(referenceDate);
      fiveYearsAgo.setFullYear(fiveYearsAgo.getFullYear() - 5);

      let today = referenceDate; // Use screening creation date as "today"

      // Sort addresses by from_date (earliest first)
      let sortedAddresses = [...this.address_Info]
        .map(a => ({
          ...a,
          effectiveToDate: a.to_date ? new Date(a.to_date) : today
        }))
        .sort((a, b) => new Date(a.from_date) - new Date(b.from_date));

      // 🔥 Utility to format duration
      const getDurationBreakdown = (start, end) => {
        let startDate = new Date(start);
        let endDate = new Date(end);

        let years = endDate.getFullYear() - startDate.getFullYear();
        let months = endDate.getMonth() - startDate.getMonth();
        let days = endDate.getDate() - startDate.getDate();

        if (days < 0) {
          months--;
          days += new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate();
        }
        if (months < 0) {
          years--;
          months += 12;
        }

        const parts = [];
        if (years > 0) parts.push(`${years} year${years > 1 ? 's' : ''}`);
        if (months > 0) parts.push(`${months} month${months > 1 ? 's' : ''}`);
        if (days > 0 || parts.length === 0) parts.push(`${days} day${days > 1 ? 's' : ''}`);

        return parts.join(', ');
      };

      // 🔥 Check missing period from 5 years ago to first entry
      if (sortedAddresses.length === 0 || new Date(sortedAddresses[0].from_date) > fiveYearsAgo) {
        const start = fiveYearsAgo;
        const end = sortedAddresses.length > 0 ? new Date(sortedAddresses[0].from_date) : today;
        const daysDiff = Math.round((end - start) / (1000 * 60 * 60 * 24));
        
        // Only show gap if there's more than 1 day difference
        if (daysDiff > 1) {
          gaps.push({
            start,
            end,
            days: daysDiff,
            duration: getDurationBreakdown(start, end),
          });
        }
      }

      // 🔥 Check gaps between consecutive entries
      for (let i = 0; i < sortedAddresses.length - 1; i++) {
        const currentEnd = sortedAddresses[i].effectiveToDate;
        const nextStart = new Date(sortedAddresses[i + 1].from_date);

        if (currentEnd < fiveYearsAgo) continue;

        const daysDiff = Math.round((nextStart - currentEnd) / (1000 * 60 * 60 * 24));
        
        // Only show gap if there's more than 1 day difference (0 or 1 day is continuous)
        if (daysDiff > 1) {
          gaps.push({
            start: currentEnd,
            end: nextStart,
            days: daysDiff,
            duration: getDurationBreakdown(currentEnd, nextStart),
          });
        }
      }

      // 🔥 Check trailing gap from last entry to today (if not "Current Address")
      if (sortedAddresses.length > 0) {
        const lastEntry = sortedAddresses[sortedAddresses.length - 1];
        const lastEnd = lastEntry.effectiveToDate;
        
        if (!lastEntry.current_status && lastEnd < today) {
          const daysDiff = Math.round((today - lastEnd) / (1000 * 60 * 60 * 24));
          
          // Only show gap if there's more than 1 day difference
          if (daysDiff > 1) {
            gaps.push({
              start: lastEnd,
              end: today,
              days: daysDiff,
              duration: getDurationBreakdown(lastEnd, today),
            });
          }
        }
      }

      return gaps;
    },
    isFiveYearsCovered() {
      return this.gaps.length === 0;
    },
  },
  validations: {
    addressObj: {
      door_number: {
        required(value) {
          return !this.restrictValidation || required(value);
        },
      },
      city: {
        required(value) {
          return !this.restrictValidation || required(value);
        },
      },
      post_code: {
        required(value) {
          return !this.restrictValidation || required(value);
        },
      },
      country: {
        required(value) {
          return !this.restrictValidation || required(value);
        },
      },
      county: {
        required(value) {
          return !this.restrictValidation || required(value);
        },
      },
      street: {
        required(value) {
          return !this.restrictValidation || required(value);
        },
      },
      from_date: {
        isValidFromDate(value) {
          const from = new Date(value);
          if (!value || isNaN(from.getTime())) return true;
          from.setHours(0, 0, 0, 0);
          if (this.addressObj.current_status) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return from <= today;
          }

          if (!this.addressObj.to_date) return true;
          const to = new Date(this.addressObj.to_date);
          if (isNaN(to.getTime())) return true;
          to.setHours(0, 0, 0, 0);
          return from <= to;
        }
      },
      to_date: {
        isRequired(value) {
          return true; // Always valid, make optional
        }
      }
    }
  }
};
</script>

<style>
.error {
  color: red;
  font-weight: bold;
}

.card-item {
  position: relative;
  min-height: 150px;
  background: #ececec;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 0 20px #ececec;
}

.current-address {
  position: absolute;
  content: "";
  top: 0px;
  right: 15px;
  width: 100px;
  background: #2b303b;
  color: #ffffff !important;
  padding: 5px;
  border-radius: 0 5px 0 0;
}
</style>
